// Translation file for Profile page

export const profileEn = {
  'profile-heading': '{name}\'s Profile',
  'profile-card-info-title': 'Card Information',
  'profile-show-sensitive-card-info-button': 'Show sensitive card information',
  'profile-card-number-text': 'Card Number:',
  'profile-card-cvv-text': 'CVV:',
  'profile-card-expiry-text': 'Expiry date:',
  'profile-personal-info-title': 'Personal Information',
  'profile-personal-mailing-title': 'Mailing Address',
  'profile-personal-billing-title': 'Billing Address',
  'profile-firstName-label': 'First Name',
  'profile-middleName-label': 'Middle Name',
  'profile-lastName-label': 'Last Name',
  'profile-dateOfBirth-label': 'Date of Birth',
  'profile-email-label': 'Email Address',
  'profile-phone-label': 'Phone Number',
  'profile-phoneType-label': 'Phone Type',
  'profile-phoneType-mobile': 'Mobile',
  'profile-phoneType-home': 'Home',
  'profile-phoneType-work': 'Work',
  'profile-addressLine1-label': 'Address 1',
  'profile-addressLine2-label': 'Address 2',
  'profile-country-label': 'Country',
  'profile-province-label': 'Province',
  'profile-city-label': 'City',
  'profile-postalCode-label': 'Postal Code',
  'profile-update-button': 'Update',
  'profile-profile-updated-alert': 'Your profile was updated successfully.',
  'profile-danger-alert': 'An error occurred',
  'profile-get-pin-heading': 'View PIN',
  'profile-get-pin-text': 'Your PIN is <b>{pin}</b>',
  'profile-set-pin-button': 'Change PIN',
  'profile-set-pin-heading': 'Change PIN',
  'profile-get-pin-wait-text': 'This may take a minute...',
  'profile-loader-text': 'This may take a minute...',
  'profile-close-button': 'Close',
  'profile-new-pin-label': 'New PIN:',
  'profile-confirm-pin-label': 'Confirm New PIN:',
  'profile-pin-mismatch-alert':
    'The two PINs you entered do not match.',
  'profile-pin-changed-alert': 'Your PIN was changed successfully.',
  'profile-pin-invalid-alert': 'Your PIN must be 4 digits.',
  'profile-new-pin-placeholder': 'Enter a 4-digit PIN',
  'profile-confirm-pin-placeholder': 'Re-enter the new PIN',
  'profile-pin-requirements-text': 'Your PIN can\'t be the same digit four times (e.g. 1111), your card\'s last 4 digits, or based on your date of birth or phone number.',
  'profile-pin-repeated-alert': 'Your PIN can\'t be the same digit four times.',
  'profile-pin-card-digits-alert': 'Your PIN can\'t be the last 4 digits of your card.',
  'profile-pin-rejected-alert': 'We couldn\'t set this PIN. It may not meet the PIN requirements. Please try a different PIN.',
  'profile-show-passwords-label': 'Show Passwords',
  'profile-different-pin-alert':
    'Your new PIN should be different from your current PIN.',
  'profile-view-pin-button': 'View Card PIN',
  'profile-invalid-state-alert':
    'Selected Province/State does not match selected Country.',
  'profile-successful-set-pin-alert':
    'PIN successfully updated.',
  'profile-successful-set-pin-ca-alert':
    'PIN successfully updated. In Canada, your card\'s chip stores its PIN offline, so you\'ll need to visit an ATM and complete a transaction with your new PIN to activate it on the chip.',
  'profile-failed-set-pin-alert':
    'PIN could not be updated.',
  'profile-login-credentials':
    'Login Credentials',
  'profile-username-label':
    'Username',
  'profile-password-label':
    'Password',
  'profile-confirm-password-heading': 'Confirm Your Password',
  'profile-confirm-password-text':
    'For your security, please re-enter your password to continue.',
  'profile-confirm-password-error': 'Incorrect password. Please try again.',
  'profile-account-info-title': 'Direct Deposit Account Information',
  'profile-account-info-account-number-label': 'Account Number:',
  'profile-account-info-transit-number-label': 'Transit Number:',
  'profile-account-info-institution-number-label': 'Institution Number:',
  'profile-account-info-routing-number-label': 'Routing Number:',
  'profile-errors-email-invalid': 'Enter a valid email address',
  'profile-errors-phone-required': 'Phone number is required',
  'profile-errors-phone-invalid': 'Phone number must be 7 to 16 digits, with no spaces or symbols',
  'profile-errors-address1-required': 'Address 1 is required',
  'profile-errors-address1-invalid':
    'Address 1 may only contain up to 40 letters (including accented letters), numbers, spaces and the characters \' , - .',
  'profile-errors-address2-invalid':
    'Address 2 may only contain up to 30 letters (including accented letters), numbers, spaces and the characters \' # , - .',
  'profile-errors-city-required': 'City is required',
  'profile-errors-postalCode-required': 'Postal code is required',
};

export const profileFr = {
  'profile-heading': 'Profil de {name}',
  'profile-card-info-title': 'Informations sur la carte',
  'profile-show-sensitive-card-info-button':
    'Afficher les informations sensibles de la carte',
  'profile-card-number-text': 'Numéro de la carte:',
  'profile-card-cvv-text': 'VVC:',
  'profile-card-expiry-text': 'Date d\'expiration:',
  'profile-personal-info-title': 'Informations personnelles',
  'profile-personal-mailing-title': 'Adresse Postale',
  'profile-personal-billing-title': 'Adresse de Facturation',
  'profile-firstName-label': 'Prénom',
  'profile-middleName-label': 'Deuxième nom',
  'profile-lastName-label': 'Nom de famille',
  'profile-dateOfBirth-label': 'Date de naissance',
  'profile-email-label': 'Adresse courriel',
  'profile-phone-label': 'Numéro de téléphone',
  'profile-phoneType-label': 'Type de téléphone',
  'profile-phoneType-mobile': 'Mobile',
  'profile-phoneType-home': 'Domicile',
  'profile-phoneType-work': 'Travail',
  'profile-addressLine1-label': 'Adresse 1',
  'profile-addressLine2-label': 'Adresse 2',
  'profile-country-label': 'Pays',
  'profile-province-label': 'Province',
  'profile-city-label': 'Ville',
  'profile-postalCode-label': 'Code Postal',
  'profile-update-button': 'Mise à jour',
  'profile-profile-updated-alert': 'Votre profil a été mis à jour avec succès.',
  'profile-danger-alert': 'Une erreur est survenue',
  'profile-get-pin-heading': 'Afficher NIP',
  'profile-get-pin-text': 'Votre code NIP est <b>{pin}</b>',
  'profile-set-pin-button': 'Changer NIP',
  'profile-set-pin-heading': 'Changer NIP',
  'profile-get-pin-wait-text': 'Cela peut prendre une minute ...',
  'profile-loader-text': 'Cela peut prendre une minute ...',
  'profile-close-button': 'Proche',
  'profile-new-pin-label': 'Nouveau NIP:',
  'profile-confirm-pin-label': 'Confirmer le nouveau NIP:',
  'profile-pin-mismatch-alert':
    'Les deux NIP saisis ne correspondent pas.',
  'profile-pin-changed-alert': 'Votre NIP a été modifié avec succès.',
  'profile-pin-invalid-alert': 'Votre NIP doit comporter 4 chiffres.',
  'profile-new-pin-placeholder': 'Entrez un NIP à 4 chiffres',
  'profile-confirm-pin-placeholder': 'Saisissez à nouveau le nouveau NIP',
  'profile-pin-requirements-text': 'Votre NIP ne peut pas être composé du même chiffre répété quatre fois (p. ex. 1111), des 4 derniers chiffres de votre carte, ni être basé sur votre date de naissance ou votre numéro de téléphone.',
  'profile-pin-repeated-alert': 'Votre NIP ne peut pas être composé du même chiffre répété quatre fois.',
  'profile-pin-card-digits-alert': 'Votre NIP ne peut pas correspondre aux 4 derniers chiffres de votre carte.',
  'profile-pin-rejected-alert': 'Nous n\'avons pas pu définir ce NIP. Il ne respecte peut-être pas les exigences relatives au NIP. Veuillez essayer un autre NIP.',
  'profile-show-passwords-label': 'Afficher les mots de passe',
  'profile-different-pin-alert':
    'Votre nouvelle NIP doit être différente de votre NIP actuelle.',
  'profile-view-pin-button': 'Afficher NIP de la carte',
  'profile-invalid-state-alert':
    'La province / l\'état sélectionné ne correspond pas au pays sélectionné.',
  'profile-successful-set-pin-alert':
    'NIP mis à jour avec succès.',
  'profile-successful-set-pin-ca-alert':
    'NIP mis à jour avec succès. Au Canada, la puce de votre carte conserve son NIP hors ligne. Vous devrez donc vous rendre à un guichet automatique et effectuer une transaction avec votre nouveau NIP pour l\'activer sur la puce.',
  'profile-failed-set-pin-alert':
    'Le NIP n\'a pas pu être mis à jour.',
  'profile-login-credentials':
    'Informations d\'identification',
  'profile-username-label':
    'Nom d\'utilisateur',
  'profile-password-label':
    'Mot de passe',
  'profile-confirm-password-heading': 'Confirmez votre mot de passe',
  'profile-confirm-password-text':
    'Pour votre sécurité, veuillez saisir à nouveau votre mot de passe pour continuer.',
  'profile-confirm-password-error': 'Mot de passe incorrect. Veuillez réessayer.',
  'profile-account-info-title': 'Informations sur le dépôt direct du compte',
  'profile-account-info-account-number-label': 'Numéro de compte:',
  'profile-account-info-transit-number-label': 'Numéro de transit:',
  'profile-account-info-institution-number-label': 'Numéro d\'institution:',
  'profile-account-info-routing-number-label': 'Numéro d\'acheminement:',
  'profile-errors-email-invalid': 'Entrez une adresse courriel valide',
  'profile-errors-phone-required': 'Le numéro de téléphone est requis',
  'profile-errors-phone-invalid': 'Le numéro de téléphone doit comporter de 7 à 16 chiffres, sans espaces ni symboles',
  'profile-errors-address1-required': 'L\'adresse 1 est requise',
  'profile-errors-address1-invalid':
    'L\'adresse 1 peut contenir au plus 40 lettres (y compris les lettres accentuées), chiffres, espaces et les caractères \' , - .',
  'profile-errors-address2-invalid':
    'L\'adresse 2 peut contenir au plus 30 lettres (y compris les lettres accentuées), chiffres, espaces et les caractères \' # , - .',
  'profile-errors-city-required': 'La ville est requise',
  'profile-errors-postalCode-required': 'Le code postal est requis',
};
